import {
  ApiResponse,
  RoleDownloadResponse,
  RoleFileTypeResponse,
  RoleUIResponse,
} from "../../models/ApiResponse";
import {
  AddRoleRequest,
  UpdateRoleRequest,
} from "../../models/requestModels/roleRequest";
import { RoleResponse } from "../../models/responseModels/roleResponse";
import { axiosRequests } from "../axiosRequest";

export const RoleAgent = {
  getRoleList: (forFdp: boolean) => axiosRequests.get<RoleUIResponse>(`/auth/roles?forFdp=${forFdp}`),
  roleCsvDownload: (roleData: RoleResponse[]) =>
    axiosRequests.post<RoleDownloadResponse>("/role/DownloadCsv", roleData),
  roleXlsxDownload: (roleData: RoleResponse[]) =>
    axiosRequests.postXlsx<Blob>("/role/DownloadXlsx", roleData),
  updateRole: (roleData: UpdateRoleRequest) =>
    axiosRequests.post<ApiResponse>("/role/updateRole", roleData),
  addRole: (roleData: AddRoleRequest) =>
    axiosRequests.post<ApiResponse>("/role/addRole", roleData),
  fetchFileTypeForRoles: (roleNames: String[]) =>
    axiosRequests.get<RoleFileTypeResponse>(`/auth/role/file-types?roles=${roleNames}`),
};
